module.exports = __webpack_public_path__ + "static/sc1-ee04b03f23cc0059d4a0480e7e364368.png";